export const ARTICLE_SOURCES_FACET = "ARTICLE_SOURCES_FACET";
export const CA_SHOW_ALTERNATIVES_ALWAYS = "CA_SHOW_ALTERNATIVES_ALWAYS";
export const CA_SHOW_CUSTOMER_ARTICLE_GROUPING_LINK = "CA_SHOW_CUSTOMER_ARTICLE_GROUPING_LINK";
export const CA_USE_METROX_ACCOUNT_FLYOUT = "CA_USE_METROX_ACCOUNT_FLYOUT";
export const CIA_NEW_ACCOUNT_FLYOUT_FALLBACK = "CIA_NEW_ACCOUNT_FLYOUT_FALLBACK";
export const CIA_NEW_CREATE_LISTS_BUTTON = "CIA_NEW_CREATE_LISTS_BUTTON";
export const CIA_NEW_CUSTOMER_PORTAL = "CIA_NEW_CUSTOMER_PORTAL";
export const CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION = "CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION";
export const CIA_REORDER_BUTTON = "CIA_REORDER_BUTTON";
export const CIA_BANNER_CAROUSEL = "CIA_BANNER_CAROUSEL";
export const CI_ARTICLE_BANNER = "CI_ARTICLE_BANNER";
export const CIA_SAVED_SEARCH = "CIA_SAVED_SEARCH";
export const CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE = "CI_BLOCK_OLD_TERMS_AND_CONDITIONS_PAGE";
export const CI_ENABLE_BANNER_FLAVOR = "CI_ENABLE_BANNER_FLAVOR";
export const CI_ENABLE_BANNER_GIFS = "CI_ENABLE_BANNER_GIFS";
export const CI_MULTIPLE_CREATIVES = "CI_MULTIPLE_CREATIVES";
export const CI_NEW_FOOTER = "CI_NEW_FOOTER";
export const CI_NEW_STORELIST_PAGE = "CI_NEW_STORELIST_PAGE";
export const CI_SL_CASH_AND_CARRY_VISIBLE = "CI_SL_CASH_AND_CARRY_VISIBLE";
export const CI_STORELIST_MAX_CSV_UPLOAD = "CI_STORELIST_MAX_CSV_UPLOAD";
export const CUSTOMER_CATEGORY_GROUP_BANNER_PLACEMENT = "CUSTOMER_CATEGORY_GROUP_BANNER_PLACEMENT";
export const ENABLE_FIXED_WIDTH_CONTENT = "ENABLE_FIXED_WIDTH_CONTENT";
export const ENABLE_NEXTCMS_COOKIE_DISCLAIMER = "ENABLE_NEXTCMS_COOKIE_DISCLAIMER";
export const ENABLE_NEXTCMS_FOOTER = "ENABLE_NEXTCMS_FOOTER";
export const ENABLE_ORDER_HABITS = "ENABLE_ORDER_HABITS";
export const ENABLE_SIDE_CADDY = "ENABLE_SIDE_CADDY";
export const EV_ALTERNATIVES_POPUP_BEHAVES_INVERSED = "EV_ALTERNATIVES_POPUP_BEHAVES_INVERSED";
export const EV_SHOW_LASTCHANCE_STOCK_COUNTER = "EV_SHOW_LASTCHANCE_STOCK_COUNTER";
export const EV_SHOW_MRPRICE = "EV_SHOW_MRPRICE";
export const HINTS_ON_I18N = "HINTS_ON_I18N";
export const LISTPAGE_SORTING_SCORING = "LISTPAGE_SORTING_SCORING";
export const METRO_X_ACCOUNT_SELECT = "METRO_X_ACCOUNT_SELECT";
export const METRO_X = "METRO_X";
export const NEW_ARTICLE_BADGE = "NEW_ARTICLE_BADGE";
export const OC_CUSTOMER_SURVEY = "OC_CUSTOMER_SURVEY";
export const OC_FSD_DELIVERY_DATE_BEFORE_CHECKOUT = "OC_FSD_DELIVERY_DATE_BEFORE_CHECKOUT";
export const SD_ALTERNATIVE_STEMMING = "SD_ALTERNATIVE_STEMMING";
export const SD_BOOST_ARTICLE_ATTRIBUTES = "SD_BOOST_ARTICLE_ATTRIBUTES";
export const SD_BOOST_CUSTOMER_TARGET_GROUPS = "SD_BOOST_CUSTOMER_TARGET_GROUPS";
export const SD_BOOST_OWN_BRAND = "SD_BOOST_OWN_BRAND";
export const SD_REDUCE_BOOST_DESCRIPTION_FIELD = "SD_REDUCE_BOOST_DESCRIPTION_FIELD";
export const SD_BULK_PRICES = "SD_BULK_PRICES";
export const SD_FOR_DEBUG_ONLY_SHOW_EV_ALTERNATIVES_COMPONENT = "SD_FOR_DEBUG_ONLY_SHOW_EV_ALTERNATIVES_COMPONENT";
export const SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS =
	"SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS";
export const SD_NO_INFO_SUGGESTIONS = "SD_NO_INFO_SUGGESTIONS";
export const SD_PARTICIPATES_IN_LTR_TEST = "SD_PARTICIPATES_IN_LTR_TEST";
export const SD_SHOW_ARTICLLESEARCH_CSAT = "SD_SHOW_ARTICLLESEARCH_CSAT";
export const SD_SHOW_METRO_X_STORE_SELECTOR_CCOV = "SD_SHOW_METRO_X_STORE_SELECTOR_CCOV";
export const SD_SHOW_METRO_X_STORE_SELECTOR_FSD = "SD_SHOW_METRO_X_STORE_SELECTOR_FSD";
export const SD_SUBCATEGORIES_PANEL = "SD_SUBCATEGORIES_PANEL";
export const SD_SUBCATEGORIES_PANEL_SEARCHPAGE = "SD_SUBCATEGORIES_PANEL_SEARCHPAGE";
export const SD_SUGGEST_CONTENT = "SD_SUGGEST_CONTENT";
export const SD_USE_EXTERNAL_NAVIGATION = "SD_USE_EXTERNAL_NAVIGATION";
export const SD_X_FOR_Y = "SD_X_FOR_Y";
export const SEARCH_DEBUG = "SEARCH_DEBUG";
export const SHOW_MERCHANT_OFFER_PAGE = "SHOW_MERCHANT_OFFER_PAGE";
export const SUGGESTIONS_DEBUG = "SUGGESTIONS_DEBUG";
export const TOUCH_SCREEN_UI = "TOUCH_SCREEN_UI";
export const SD_SHOW_ADD_TO_CART_IN_SUGGESTIONS = "SD_SHOW_ADD_TO_CART_IN_SUGGESTIONS";
export const SD_SHOW_STORE_CUTOFF_TIME_FOR_TRADERS = "SD_SHOW_STORE_CUTOFF_TIME_FOR_TRADERS";
